"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentViewHeader = exports.ContentView = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var create_rocket_1 = require("../_util/create-rocket");
var icon_1 = require("../icon");
var justify_1 = require("../justify");
var heading_1 = require("../heading");
var config_context_1 = require("../_util/config-context");
/**
 * @deprecated
 *
 * 请使用 Layout 组件代替
 */
exports.ContentView = Object.assign(create_rocket_1.createRocket("ContentView", "div.@{prefix}-content"), {
    Header: ContentViewHeader,
    Body: ContentViewBody,
});
function ContentViewHeader(_a) {
    var showBackButton = _a.showBackButton, _b = _a.onBackButtonClick, onBackButtonClick = _b === void 0 ? function () { return null; } : _b, title = _a.title, subtitle = _a.subtitle, operation = _a.operation, children = _a.children, className = _a.className, style = _a.style;
    var classPrefix = config_context_1.useConfig().classPrefix;
    if (children) {
        return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-content__header", className), style: style }, children));
    }
    return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-content__header", className), style: style },
        react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement(react_1.default.Fragment, null,
                showBackButton && (react_1.default.createElement("a", { className: classPrefix + "-content__header-back", onClick: onBackButtonClick },
                    react_1.default.createElement(icon_1.Icon, { type: "btnback" }))),
                react_1.default.createElement(heading_1.H2, null, title),
                react_1.default.createElement("span", { className: classPrefix + "-content-header__text" }, subtitle)), right: operation })));
}
exports.ContentViewHeader = ContentViewHeader;
function ContentViewBody(_a) {
    var _b;
    var full = _a.full, sidebar = _a.sidebar, children = _a.children, className = _a.className, style = _a.style;
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-content__body", className, {
            "has-subsidebar": sidebar,
        }), style: style },
        react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-content__inner", (_b = {},
                _b[classPrefix + "-content__inner--full"] = full,
                _b)) },
            sidebar && react_1.default.createElement("div", { className: classPrefix + "-sidebar" }, sidebar),
            children)));
}
//# sourceMappingURL=ContentView.js.map